import React, { Component, Fragment } from "react";
import MetaTags from "react-meta-tags";
import NasHeader from "../../layouts/_nas/NasHeader";
import NasFooter from "../../layouts/_nas/NasFooter";
import NasDonationPageContent from "../../sections/_nas/NasDonationPageContent";

class NasDonationPage extends Component {
  render() {
    return (
      <>
        <MetaTags>
          <title>Holy Spirit Church | Donations</title>
          <meta
            name="description"
            content="Support the mission of Holy Spirit Church with a secure online donation."
          />
        </MetaTags>
        <NasHeader />
        <NasDonationPageContent />
        <NasFooter />
      </>
    );
  }
}

export default NasDonationPage;
